import AICampusFooter from "@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue";
import GlobalTable from "@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue";
import ProfileInfo from '@/views/probaworkflows_base/entity/profile_info/ProfileInfo.vue';
import {
  GET_JOB_PROFILE_DETAILS_URL,
  CHECK_APPLIED_STATUS_URL,
  GET_USER_APPLIED_ENTITY_TYPE_IDS_URL,
  PUBLIC_JOB_ADVERT_URL,
  PUBLIC_JOB_CATALOG_URL,
  GET_USER_PROFILE_DETAILS_URL,
  APPLY_FOR_ENTITY_TYPE,
  GET_ALL_USER_APPLICATIONS,
  WITHDRAW_APPLICATION_URL,
  GET_ENTITY_BY_USER,
  GET_APPLICATION_FORMS,
  get_headers,
  get_token,
  LIST_ENTITY_ASSESSMENTS,
  STATUS_KEY_TO_FILTER,
} from "@/utils/constants/constants";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import axios from "axios";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from 'jquery';

function normalize_entity_type_id(entity_type_id) {
  const normalized_id = Number(entity_type_id);
  return Number.isFinite(normalized_id) && normalized_id > 0 ? normalized_id : null;
}

export default {
  name: "ViewTrustForm",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    AICampusFooter,
    ProfileInfo,
  },
  data: () => ({
    hostname: window.location.hostname,
    activeTab: 'profile',
    applicationTrackerTab: 'all_jobs',
    current_user_name: sessionStorage.getItem('lead_name') || '',
    headers: "",
    vacancies: [],
    loading_jobs: false,
    jobs_data_loaded: false,
    jobs_data_loading: false,
    profile: {
      fullName: '',
      email: '',
      phone: '',
      idNumber: '',
      gender: '',
      nationality: '',
      address: '',
      qualifications: '',
    },
    application_list: [],
    application_table_headers: [],
    table_safe_application_list: [],
    selected_status: null,
    filter_by: [],
    showVacancyFilters: false,
    vacancy_filters: {
      programmeId: '',
      status: '',
      search: '',
      datePosted: 'any_time',
    },
    vacancy_current_page: 1,
    vacancy_page_size: 10,
    status_options: [
      { value: '', label: 'All Statuses' },
      { value: 'Open', label: 'Open' },
      { value: 'Closing Soon', label: 'Closing Soon' },
      { value: 'Closed', label: 'Closed' },
    ],
    stored_form_count: null,
    total_assessment_count: 0,
    entities_for_user: [],
    total_pre_assessment_count: 0,
    total_post_assessment_count: 0,
    form_count: 0,
    DROPDOWN_STATUS_KEYS: ["approved", "declined", "pending"],
    STATUS_ALIASES: {
      pending: "in-progress",
      declined: "not-approved",
    },
    loading_profile: false,
    opening_application: false,
    profile_completion_value: 0,
    profile_completion_ready: false,
    profile_completion_buffer: null,
    profile_completion_timer: null,
    applied_status_map: {},
    job_profile: {
      title: '',
      description: '',
      sections: [],
      advert_details: '',
      advert_sections: [],
      advert_order: [],
      display_blocks: [],
    },
    job: {
      id: null,
      title: '',
      jobTitle: '',
      departmentName: '',
      recruitingPeriod: '',
      alreadyApplied: false,
      applicationState: null,
      formSections: [],
      competencies: [],
    },
  }),

  mounted() {
    sessionStorage.removeItem('entity_applying');
    this.headers = get_headers();
    this.apply_status_from_route();
    this.apply_jobs_tab_from_route();
    this.fetch_profile_basic();
    this.load_initial_tab_data();
  },

  beforeUnmount() {
    if (this.profile_completion_timer) {
      clearTimeout(this.profile_completion_timer);
      this.profile_completion_timer = null;
    }
  },
  computed: {
    visible_profile_sections() {
      if (!this.job_profile?.sections) return [];
      return this.job_profile.sections.filter((section) => section.show_on_advert !== false);
    },

    stats() {
    const list = this.application_list || [];

    const total = list.length;

    const approved = list.filter(app =>
      (app?.status?.status || "").toLowerCase().includes("approved")
    ).length;

    const declined = list.filter(app =>
      (app?.status?.status || "").toLowerCase().includes("declined")
    ).length;

    const shortlisted = list.filter(app =>
      (app?.status?.status || "").toLowerCase().includes("shortlisted")
    ).length;

    return {
      submitted: total,
      shortlisted,
      declined,
      approved,
      vacancies: this.vacancies.length,
    };
  },
    profile_fields() {
      return [
        { label: 'Phone',          value: this.profile.phone },
        { label: 'ID Number',      value: this.profile.idNumber },
        { label: 'Gender',         value: this.profile.gender },
        { label: 'Nationality',    value: this.profile.nationality },
        { label: 'Address',        value: this.profile.address },
        { label: 'Qualifications', value: this.profile.qualifications },
      ];
    },

    profile_completion() {
      return this.profile_completion_value;
    },

    applied_applications() {
      return (this.table_safe_application_list || []).filter(row => !row._is_withdrawn);
    },

    filtered_applied_applications() {
      return this.applied_applications.filter((row) => this.is_within_selected_date(row._date_created_raw));
    },

    withdrawn_applications() {
      return (this.table_safe_application_list || []).filter(row => row._is_withdrawn);
    },

    filtered_withdrawn_applications() {
      return this.withdrawn_applications.filter((row) => this.is_within_selected_date(row._date_created_raw));
    },

    approved_count() {
      return this.applied_applications.filter(r =>
        (r['Status'] || '').toLowerCase().includes('approved')
      ).length;
    },

    has_approved_application() {
      return this.approved_count > 0;
    },

    application_tracker_tabs() {
      return [
        { key: 'all_jobs', label: 'All Jobs', count: this.vacancies.length },
        { key: 'applied', label: 'Applied', count: this.applied_applications.length },
        { key: 'archived', label: 'In Progress', count: this.archived_vacancies.length },
        { key: 'withdrawn', label: 'Withdrawn', count: this.withdrawn_applications.length },
      ];
    },

    is_all_jobs_tracker_tab() {
      return this.applicationTrackerTab === 'all_jobs';
    },

    is_applied_tracker_tab() {
      return this.applicationTrackerTab === 'applied';
    },

    is_archived_tracker_tab() {
      return this.applicationTrackerTab === 'archived';
    },

    is_withdrawn_tracker_tab() {
      return this.applicationTrackerTab === 'withdrawn';
    },

    selected_application_tracker() {
      return this.application_tracker_tabs.find(tab => tab.key === this.applicationTrackerTab) || this.application_tracker_tabs[0];
    },

    tracker_empty_state_title() {
      if (this.is_applied_tracker_tab) return 'No applications yet';
      if (this.is_archived_tracker_tab) return 'No in-progress jobs';
      if (this.is_withdrawn_tracker_tab) return 'No withdrawn applications';
      return 'No jobs here';
    },

    tracker_empty_state_message() {
      if (this.is_all_jobs_tracker_tab) {
        return 'No vacancies are available right now. Check back soon for new opportunities.';
      }
      if (this.is_applied_tracker_tab) {
        return 'Browse available opportunities and apply to get started.';
      }
      if (this.is_archived_tracker_tab) {
        return 'Jobs you have started but not yet submitted will appear here.';
      }
      if (this.is_withdrawn_tracker_tab) {
        return 'Applications you have withdrawn will appear here.';
      }
      return `Your ${this.selected_application_tracker?.label?.toLowerCase() || 'selected'} jobs will appear here to help you stay organized.`;
    },

    vacancy_programme_options() {
      const names = [...new Set(
        (this.vacancies || []).map(v => v.departmentName).filter(n => n && n.trim())
      )];
      return names.map(name => ({ label: name, value: name }));
    },

    archived_vacancies() {
      return (this.vacancies || []).filter(job => job.applicationState === 'archived');
    },

    filtered_archived_vacancies() {
      const list = this.archived_vacancies.filter((job) => this.is_within_selected_date(job.publishedDate));
      return [...list].sort((a, b) => {
        const aDate = a.publishedDate ? new Date(a.publishedDate).getTime() : 0;
        const bDate = b.publishedDate ? new Date(b.publishedDate).getTime() : 0;
        return bDate - aDate;
      });
    },

    filtered_vacancies() {
      const search_text = (this.vacancy_filters.search || '').trim().toLowerCase();
      let filtered = (this.vacancies || []).filter((job) => {
        const matches_programme = !this.vacancy_filters.programmeId || job.departmentName === this.vacancy_filters.programmeId;
        const matches_status = !this.vacancy_filters.status || job.status === this.vacancy_filters.status;
        const matches_search = !search_text
          || (job.jobTitle || '').toLowerCase().includes(search_text)
          || (job.referenceNumber || '').toLowerCase().includes(search_text);
        const matches_date = this.is_within_selected_date(job.publishedDate);
        return matches_programme && matches_status && matches_search && matches_date;
      });
      return [...filtered].sort((a, b) => {
        const aDate = a.publishedDate ? new Date(a.publishedDate).getTime() : 0;
        const bDate = b.publishedDate ? new Date(b.publishedDate).getTime() : 0;
        return bDate - aDate;
      });
    },

    paginated_vacancies() {
      const start = (this.vacancy_current_page - 1) * this.vacancy_page_size;
      return this.filtered_vacancies.slice(start, start + this.vacancy_page_size);
    },

    vacancy_total_pages() {
      return Math.ceil(this.filtered_vacancies.length / this.vacancy_page_size);
    },
  },
  watch: {
    "$route.query.status_id"() {
      this.apply_status_from_route();
      if (this.jobs_data_loaded || this.activeTab === 'jobs') {
        this.get_user_forms(this.selected_status);
      }
    },
    activeTab(newVal) {
      if (newVal === 'jobs') {
        if (this.jobs_data_loaded) {
          this.sync_applied_statuses();
          this.sync_vacancy_applied_statuses();
          return;
        }
        this.ensure_jobs_data_loaded();
        return;
      }
    },
    table_safe_application_list() {
      if (this.activeTab === 'jobs' && this.is_applied_tracker_tab) {
        this.sync_applied_statuses();
      }
    },
    applicationTrackerTab(newVal) {
      if (this.activeTab !== 'jobs') return;
      if (newVal === 'applied') {
        this.sync_applied_statuses();
        return;
      }
      if (newVal === 'all_jobs') {
        this.sync_vacancy_applied_statuses();
      }
    },
    vacancies(newVal, oldVal) {
      // Only sync once when vacancies are first loaded - never re-fire on stamp.
      if (this.activeTab === 'jobs' && this.is_all_jobs_tracker_tab && (!oldVal || !oldVal.length) && newVal && newVal.length && !this._syncingVacancies) {
        this.sync_vacancy_applied_statuses();
      }
    },
  },

  methods: {
    logout_applicant() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push('/');
    },

    async load_initial_tab_data() {
      if (this.activeTab === 'jobs') {
        await this.ensure_jobs_data_loaded();
      }
    },

    async ensure_jobs_data_loaded() {
      if (this.jobs_data_loaded || this.jobs_data_loading) {
        return;
      }

      this.jobs_data_loading = true;

      try {
        await Promise.all([
          this.fetch_vacancies(),
          this.fetch_entities_by_user(),
          Promise.resolve(this.get_user_forms(this.selected_status)),
        ]);
        this.jobs_data_loaded = true;
      } finally {
        this.jobs_data_loading = false;
      }
    },
    extract_plain_text_content(value) {
      const markup = String(value || '');
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      return (parsed.body?.textContent || '').replace(/\r\n/g, '\n').trim();
    },
    build_plain_text_lines(value) {
      return this.extract_plain_text_content(value)
        .split('\n')
        .map(line => line.trim())
        .filter(Boolean);
    },
    get_plain_text_list_tag(list_items) {
      const has_numbered_items = list_items.some(item => item.type === 'number');
      const has_bullet_items = list_items.some(item => item.type === 'bullet');
      return has_numbered_items && !has_bullet_items ? 'ol' : 'ul';
    },

    parse_plain_text_list(content) {
      if (!content) return null;
      const lines = this.build_plain_text_lines(content);
      if (!lines.length) return null;
      const bullet_line_regex = /^[\u2022\-*]\s+(.+)$/;
      const numbered_line_regex = /^\d+[.)]\s+(.+)$/;
      const list_items = lines.map((line) => this.parse_plain_text_list_item(line, bullet_line_regex, numbered_line_regex));
      if (list_items.some(item => item.type === 'text')) return null;

      return {
        tag: this.get_plain_text_list_tag(list_items),
        items: list_items.map(item => item.text),
      };
    },
    parse_plain_text_list_item(line, bullet_line_regex, numbered_line_regex) {
      const bullet_match = line.match(bullet_line_regex);
      if (bullet_match) return { type: 'bullet', text: bullet_match[1].trim() };
      const numbered_match = line.match(numbered_line_regex);
      if (numbered_match) return { type: 'number', text: numbered_match[1].trim() };
      return { type: 'text', text: line };
    },
    coerce_text_value(value) {
      if (value === null || typeof value === 'undefined') return '';
      return typeof value === 'string' ? value : `${value}`;
    },

    is_competencies_block(block) {
      const title = this.coerce_text_value(block?.title).toLowerCase();
      return title.includes('competenc');
    },

    parse_competency_groups(content) {
      const plain_text = this.extract_plain_text_content(content);
      if (!plain_text) return [];

      const label_regex = /(Knowledge|Skills|Personal Attributes|Abilities|Attitude|Minimum Qualification|Minimum Experience)\s*:/gi;
      const matches = [...plain_text.matchAll(label_regex)];

      if (!matches.length) {
        return [];
      }

      return matches.map((match, index) => {
        const label = match[1];
        const start = match.index + match[0].length;
        const end = index + 1 < matches.length ? matches[index + 1].index : plain_text.length;
        const raw_value = plain_text.slice(start, end).trim();
        const items = raw_value
          .split(/\n+/)
          .map(item => item.replace(/^[\s\u2022;]+/, '').trim())
          .filter(Boolean);

        return {
          label,
          items,
          value: items.join(' • ') || raw_value,
        };
      }).filter(group => group.value);

    },

    render_block_html(_block, content) {
      return this.extract_plain_text_content(content);
    },

    has_table_content(section) {
      if (!section.table || !Array.isArray(section.table.rows)) return false;
      for (const row of section.table.rows) {
        if (!Array.isArray(row)) continue;
        for (const cell of row) {
          const cleaned = this.strip_html_tags(cell || '');
          if (cleaned && cleaned.trim().length > 0) return true;
        }
      }
      return false;
    },

    normalize_profile_sections(raw_sections) {
      if (!Array.isArray(raw_sections)) return [];
      return raw_sections.map(section => ({
        title: section.title || '',
        descriptions: Array.isArray(section.descriptions) ? section.descriptions : [],
        table: section.table || { headers: [{ label: 'Column 1' }], rows: [['']] },
        use_columns: section.use_columns === true,
        show_on_advert: section.show_on_advert !== false &&
          section.show_on_advert !== "false" &&
          section.show_on_advert !== 0,
      }));
    },

    split_advert_sections_and_order(raw_sections) {
      const list = Array.isArray(raw_sections) ? JSON.parse(JSON.stringify(raw_sections)) : [];
      const meta = list.find(item => item && item.type === '__display_order_meta__' && Array.isArray(item.items));
      return {
        content_sections: list.filter(item => !(item && item.type === '__display_order_meta__')),
        order_items: meta?.items || [],
      };
    },

    build_default_display_order(profile_sections, advert_details, advert_sections) {
      const order = [];
      (profile_sections || []).forEach((_, idx) => order.push({ key: `profile:${idx}`, source: 'profile', index: idx }));
      if (advert_details && String(advert_details).trim()) order.push({ key: 'details', source: 'details' });
      (advert_sections || []).forEach((_, idx) => order.push({ key: `section:${idx}`, source: 'section', index: idx }));
      return order;
    },

    normalize_display_order(saved_order, profile_sections, advert_details, advert_sections) {
      const fallback = this.build_default_display_order(profile_sections, advert_details, advert_sections);
      const allowed = new Set(fallback.map(item => item.key));
      const normalized = [];

      if (Array.isArray(saved_order)) {
        saved_order.forEach(item => {
          if (item && allowed.has(item.key) && !normalized.some(entry => entry.key === item.key)) {
            normalized.push(item);
          }
        });
      }

      fallback.forEach(item => {
        if (!normalized.some(entry => entry.key === item.key)) {
          normalized.push(item);
        }
      });

      return normalized;
    },

    refresh_job_profile_display_blocks() {
      const profile_sections = this.visible_profile_sections || [];
      const advert_sections = this.job_profile.advert_sections || [];
      const advert_details = this.job_profile.advert_details || '';
      const order = this.normalize_display_order(this.job_profile.advert_order || [], profile_sections, advert_details, advert_sections);

      this.job_profile.display_blocks = order
        .map(item => this.build_job_profile_display_block(item, profile_sections, advert_details, advert_sections))
        .filter(block => !!block.data);
    },
    build_section_display_block(item, sections) {
      return {
        key: item.key,
        kind: 'section',
        title: sections[item.index]?.title || `Section ${item.index + 1}`,
        data: sections[item.index] || null,
      };
    },
    build_details_display_block(item, advert_details) {
      return {
        key: item.key,
        kind: 'details',
        title: 'Additional Information',
        data: advert_details,
      };
    },
    build_job_profile_display_block(item, profile_sections, advert_details, advert_sections) {
      if (item.source === 'profile') {
        return this.build_section_display_block(item, profile_sections);
      }
      if (item.source === 'details') {
        return this.build_details_display_block(item, advert_details);
      }
      return this.build_section_display_block(item, advert_sections);
    },

     strip_html_tags(text) {
      if (!text) return '';
      return String(text).replace(/<[^>]+>/g, '').trim();
    },

    async open_job_details_from_application(row) {
      if (!row?._entity_type_id) {
        this.show_error("Job details not available.");
        return;
      }

      // Build minimal job object so modal header works.
      // The user is on the Applied tab Ã¢â‚¬â€ these are always already applied.
      this.job = {
        id: row._entity_type_id,
        title: row["Entity Type Name"],
        jobTitle: row["Entity Type Name"],
        departmentName: "",
        recruitingPeriod: "",
        alreadyApplied: true,
        formSections: [],
        competencies: [],
      };

      await this.load_job_profile_for_modal(row._entity_type_id, row._advert_id);
      await this.load_advert_data_for_modal(row._entity_type_id, row._advert_id);
    },

    reset_modal_advert_content() {
      this.job_profile.advert_details = '';
      this.job_profile.advert_sections = [];
      this.job_profile.advert_order = [];
      this.refresh_job_profile_display_blocks();
    },
    apply_modal_advert_content(advert) {
      const split = this.split_advert_sections_and_order(advert.sections || []);
      this.job_profile.advert_details = advert.details || '';
      this.job_profile.advert_sections = split.content_sections;
      this.job_profile.advert_order = split.order_items;
      this.refresh_job_profile_display_blocks();
    },
    load_advert_data_for_modal(entity_type_id, advert_id = null) {
      const safe_entity_type_id = normalize_entity_type_id(entity_type_id);
      if (!safe_entity_type_id) return Promise.resolve();

      return axios.get(PUBLIC_JOB_ADVERT_URL, {
        params: { entity_type_id: safe_entity_type_id },
      })
        .then((response) => {
          const adverts = Array.isArray(response.data?.data) ? response.data.data : [];
          const advert = response.data?.status === 'success'
            ? this.find_modal_advert(adverts, advert_id)
            : null;
          if (!advert) {
            this.reset_modal_advert_content();
            return;
          }
          this.apply_modal_advert_content(advert);
        })
        .catch((error) => {
          console.warn('Could not load advert data:', error.message);
          this.reset_modal_advert_content();
        });
    },
    advert_modal_sort_value(advert) {
      return new Date(advert?.updated_at || advert?.date_modified || advert?.date_created || 0).getTime();
    },
    sort_modal_adverts(adverts) {
      return adverts.slice().sort((left, right) => {
        const left_time = this.advert_modal_sort_value(left);
        const right_time = this.advert_modal_sort_value(right);
        if (left_time !== right_time) {
          return right_time - left_time;
        }
        return (Number(right?.id) || 0) - (Number(left?.id) || 0);
      });
    },
    is_matching_modal_advert(row, advert_id) {
      return Number(row?.id) === Number(advert_id);
    },
    find_modal_advert(adverts, advert_id) {
      const sorted_adverts = this.sort_modal_adverts(adverts);
      if (!advert_id) {
        return sorted_adverts[0];
      }
      const has_exact_match = sorted_adverts.some(item => this.is_matching_modal_advert(item, advert_id));
      return sorted_adverts.find((row, index) => this.is_matching_modal_advert(row, advert_id) || (index === 0 && !has_exact_match));
    },

    async load_job_profile_for_modal(entity_type_id, advert_id = null) {
      if (!entity_type_id) return;
      this.loading_profile = true;
      this.job_profile = {
        title: '',
        description: '',
        sections: [],
        advert_details: '',
        advert_sections: [],
        advert_order: [],
        display_blocks: [],
      };

      try {
        // Always send auth headers Ã¢â‚¬â€ Django will include already_applied when user is logged in.
        const response = await axios.get(GET_JOB_PROFILE_DETAILS_URL, {
          params: { entity_type_id, advert_id },
          headers: get_headers(),
        });

        const wrapper = response.data || {};
        const data = wrapper.data || wrapper;

        if (data && typeof data === 'object') {
          this.job_profile = {
            title: data.job_title || data.title || this.job.jobTitle || 'Untitled Job Profile',
            description: data.description || '',
            sections: this.normalize_profile_sections(data.sections || []),
            advert_details: '',
            advert_sections: [],
            advert_order: [],
            display_blocks: [],
          };
          this.refresh_job_profile_display_blocks();
        }

        const application_state = this.normalize_application_state(wrapper.application_state);
        if (application_state) {
          this.job = {
            ...this.job,
            applicationState: application_state,
            alreadyApplied: application_state === 'applied',
          };
        }
      } catch (error) {
        console.warn('Could not load job profile details:', error.message);
      } finally {
        this.loading_profile = false;
      }
    },
    set_status_filter(key) {
      this.selected_status = (key || "");
        sessionStorage.setItem("filter_by", JSON.stringify([this.selected_status]));
        const normalized = this.normalize_key(this.selected_status);

        // server filter value using your constant (e.g., APPROVED, DECLINED, IN_PROGRESS)
        const serverFilter = normalized ? Reflect.get(STATUS_KEY_TO_FILTER, normalized) : null;
        this.get_user_forms(serverFilter);
    },

    apply_status_from_route() {
      var status = this.$route.query.status_id;
      this.selected_status = status || null;
    },

    apply_jobs_tab_from_route() {
      const tab = String(this.$route?.query?.tab || '').trim().toLowerCase();
      const tracker = String(this.$route?.query?.tracker || '').trim().toLowerCase();
      const allowed_trackers = ['all_jobs', 'applied', 'archived', 'withdrawn'];

      if (tab === 'jobs') {
        this.activeTab = 'jobs';
      }

      if (allowed_trackers.includes(tracker)) {
        this.applicationTrackerTab = tracker;
      }
    },

    get_user_forms(filter = null) {
      this.application_list = [];

      // send server-side filter if present
      const params = {filter_by: filter};

      return axios
        .get(GET_ALL_USER_APPLICATIONS, {
          headers: this.headers,
          params,
        })
        .then((response) => {
          const data = response.data?.data || [];
          this.application_list = data.filter((application) => {
            const normalized_form_type = String(application?.form_type || "")
              .trim()
              .toLowerCase()
              .replace(/_/g, " ");
            return normalized_form_type === "entity form";
          });

          this.prep_tables();
        })
        .catch((error) => {
          const message =
            error.response?.data?.message || error.message || "Unknown error";
          this.show_error("Error getting forms: " + message);
        });
    },

    prep_tables() {
      const rows = (this.application_list || []).map((application) => {
        const child = application?.current_entity;
        const child_type = application?.current_entity_type;

        // Get the entity name here
        const entity_name = this.get_entity_name(application);

        return {
          "Application No": application?.advert_reference_number || application?.reference_number || application?.id || "",
          "Job Advertised": application?.advert_title || child_type?.entity_type_name || application?.entity_type?.entity_type_name || "",
          "Date Created": this.formatApplicationDate(application?.date_created),
          Status: (application?.status?.status ?? "").replace("_", " "),
          _application_form_id: application?.current_application_form_id ?? application?.application_form_id ?? null,
          _application_id: application?.id ?? null,
          _entity_profile_id: child?.id ?? application?.entity ?? null,
          _child_entity_type_id: child_type?.id ?? null,
          _parent_entity_profile_id: application?.entity ?? null,
          _entity_type_id: child_type?.id ?? application?.entity_type?.id ?? null,
          _advert_id: application?.advert_id ?? application?.advert?.id ?? null,
          _entity_name: entity_name,
          _entity_type_name: child_type?.entity_type_name ?? application?.entity_type?.entity_type_name ?? "",
          _date_created_raw: application?.date_created ?? null,
          _is_withdrawn: application?.is_withdrawn ?? false,
        };
      });

      this.application_table_headers = rows.length
        ? Object.keys(rows[0]).filter((k) => !k.startsWith("_")).concat(["Actions"])
        : ["Application No", "Job Advertised", "Date Created", "Status", "Actions"];

      this.table_safe_application_list = rows;
    },

    get_entity_name(application) {

      if (application?.current_entity_name) {
        return application.current_entity_name.trim();
      }

      const child_user = application?.current_entity?.user;
      if (child_user?.first_name && child_user?.last_name) {
        return `${child_user.first_name} ${child_user.last_name}`.trim();
      }

      const parent_user = application?.profile_role?.[0]?.user;
      if (parent_user?.first_name && parent_user?.last_name) {
        return `${parent_user.first_name} ${parent_user.last_name}`.trim();
      }
      return "Unknown Entity";
    },


    // Add this helper method to handle the date formatting
    formatApplicationDate(dateString) {
      if (!dateString) return "";

      try {
        // If the date is already in the format "Tue 19 August 2025 09:48"
        if (typeof dateString === "string" && dateString.includes("August")) {
          return dateString;
        }

        // If it's a proper date string that can be parsed
        const date = new Date(dateString);
        return new Intl.DateTimeFormat("en-GB", {
          weekday: "short",
          day: "numeric",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }).format(date);
      } catch (error) {
        return dateString;
      }
    },

    initialize_data_table(retries = 0) {
      if (this.activeTab !== 'jobs' || !this.is_applied_tracker_tab || !this.filtered_applied_applications.length) {
        return;
      }

      this.$nextTick(() => {

        const target = $('#entity_form_management_table');
        if (!target.length) {
          if (retries < 5) {
            setTimeout(() => this.initialize_data_table(retries + 1), 100);
          }
          return;
        }

        this.dataTable = target.DataTable({
          data: this.filtered_applied_applications,
          responsive: true,
          searching: true,
          paging: true,
          pageLength: 10,
          columns: [
            { data: 'Application No', className: 'text-xxs' },
            { data: 'Job Advertised', className: 'text-xxs' },
            { data: 'Date Created', className: 'text-xxs' },
            {
              data: null,
              orderable: false,
              searchable: false,
              className: 'text-xxs',
              render: (data, type, row) => {
                const name = (row._entity_name || '').replace(/"/g, '&quot;');
                const typeName = (row._entity_type_name || '').replace(/"/g, '&quot;');
                return `<button class="btn btn-primary-dark btn-sm rounded-small text-xxs text-dark vtf-dt-view"
                          data-app="${row['_application_id'] || ''}"
                          data-status="${row['Status'] || ''}"
                          data-profile="${row['_entity_profile_id'] || ''}"
                          data-etype="${row['_entity_type_id'] || ''}"
                          data-name="${name}"
                          data-etype-name="${typeName}">View</button>
                        <button class="btn btn-outline-danger btn-sm rounded-small text-xxs ms-1 vtf-dt-withdraw"
                          data-app="${row['_application_id'] || ''}">Withdraw</button>`;
              },
            },
          ],
          language: {
            search: '',
            searchPlaceholder: 'Search applications...',
            lengthMenu: '_MENU_ per page',
            info: 'Showing _START_\u2013_END_ of _TOTAL_ entries',
            infoEmpty: 'No entries to show',
            emptyTable: 'No applications found',
            paginate: { previous: '\u2039', next: '\u203a' },
          },
        });

        // Event delegation Ã¢â‚¬â€ DataTables owns tbody so Vue @click won't fire
        target.off('click', '.vtf-dt-view').on('click', '.vtf-dt-view', (e) => {
          const btn = $(e.currentTarget);
          this.view_entity_application_overview(
            btn.data('app'),
            btn.data('status'),
            btn.data('profile'),
            btn.data('etype'),
            btn.data('name'),
            btn.data('etype-name')
          );
        });

        target.off('click', '.vtf-dt-withdraw').on('click', '.vtf-dt-withdraw', (e) => {
          const btn = $(e.currentTarget);
          this.withdraw_application(btn.data('app'));
        });
      });
    },

    view_entity_application_overview(application_id, status, entity_profile_id, entity_type_id, entity_name,entity_type_name) {
      // Persist all data including entity_name
      sessionStorage.setItem("application_id", application_id);
      sessionStorage.setItem("application_status", status);
      sessionStorage.setItem("entity_profile_id", entity_profile_id);
      sessionStorage.setItem("entity_type_id", entity_type_id);
      sessionStorage.setItem("entity_name", entity_name); // Store the entity name
      sessionStorage.setItem("entity_type_name", entity_type_name);

      this.$router.push({
        name: "entity_application_overview",
        params: {
          application_no: application_id,
          status: status,
          entity_profile_id: entity_profile_id,
          entity_type_id: entity_type_id,
          entity_name: entity_name // Pass as param
        },
        query: {
          application_id: application_id,
          entity_profile_id: entity_profile_id,
          entity_type_id: entity_type_id,
          entity_type_name : entity_type_name,
          entity_name: entity_name // Also pass as query parameter for reliability
        }
      });
    },
    
    view_profile_main() {
  // Try to get the latest application first
  const latestApplication = this.applied_applications?.[0];

  if (latestApplication) {
    this.view_entity_application_overview(
      latestApplication._application_id,
      latestApplication['Status'],
      latestApplication._entity_profile_id,
      latestApplication._entity_type_id,
      latestApplication._entity_name
    );
    return;
  }

  this.activeTab = 'jobs';
  this.applicationTrackerTab = 'all_jobs';
  this.show_info("You have not applied for a job yet.");
},

    async fetch_assessments() {
      const entity_type_id = sessionStorage.getItem("entity_type_id");
      if (!entity_type_id) {
        return;
      }

      try {
        const resp = await axios.get(LIST_ENTITY_ASSESSMENTS, {
          params: { entity_type_id: entity_type_id },
          headers: this.headers,
        });
        const body = resp.data;
        if (body.status === "success") {
          this.total_assessment_count = body.total_assessments;
          this.total_pre_assessment_count = body.total_pre_assessments;
          this.total_post_assessment_count = body.total_post_assessments;
        } else {
          this.total_assessment_count = 0;
        }
      } catch (err) {
        if (err.response?.status === 404) {
          this.total_assessment_count = 0;
          return;
        }
        let payload = err.response?.data;
        if (typeof payload === "string") {
          try {
            payload = JSON.parse(payload);
          } catch {
            payload = { message: "Error parsing response" };
          }
        }
        const msg = payload?.message || err.message;
        this.show_error("Assessments", msg);
      }
    },

    async fetch_entities_by_user() {
      const user_id = sessionStorage.getItem("user_id");
      if (!user_id) return;
      await this.load_user_entities(user_id);
    },

    /* eslint-disable no-useless-catch */
    load_user_entities(user_id) {
      return axios
        .get(GET_ENTITY_BY_USER, {
          params: { user_id: user_id, filter_by: this.selected_status },
          headers: this.headers || {},
        })
        .then(({ data: body }) => {
          if (body.status === "success") {
            this.entities_for_user = body.data;
          } else {
            this.show_error(
              "Entities",
              body.message || "Could not load entities"
            );
          }
        })
        .catch((err) => {
          if (err.response?.status === 404) return;

          const payload =
            typeof err.response?.data === "string"
              ? JSON.parse(err.response.data)
              : err.response?.data || {};
          this.show_error("Entities", payload.message || err.message);
        });
    },

    redirect_to_view_jobs_advertised() {
      this.activeTab = 'jobs';
      this.applicationTrackerTab = 'all_jobs';
    },

    status_class(status) {
      if (!status) return '';
      const s = String(status).trim().toLowerCase();
      if (s.includes('approved') || s.includes('success')) return 'badge-success';
      if (s.includes('review') || s.includes('pending') || s.includes('progress')) return 'badge-warning';
      if (s.includes('reject')   || s.includes('withdraw')) return 'badge-danger';
      return 'badge-secondary';
    },

    read_prop(target, key, fallback = null) {
      if (!target || !Reflect.has(target, key)) return fallback;
      const value = Reflect.get(target, key);
      return value ?? fallback;
    },

    infer_job_status(closing_date) {
      if (!closing_date) return 'Open';
      const now = new Date();
      const closing = new Date(closing_date);
      const days_remaining = (closing.getTime() - now.getTime()) / (1000 * 60 * 60 * 24);
      if (days_remaining < 0) return 'Closed';
      if (days_remaining <= 7) return 'Closing Soon';
      return 'Open';
    },

    get_status_badge_class(status) {
      const normalized_status = String(status || '').trim().toLowerCase();
      if (normalized_status.includes('closed')) return 'status-badge-closed';
      if (normalized_status.includes('closing soon') || normalized_status.includes('progress')) return 'status-badge-closing-soon';
      return 'status-badge-open';
    },

    normalize_application_state(state) {
      return ['applied', 'archived'].includes(state) ? state : null;
    },

    get_application_state_badge_class(state) {
      if (state === 'applied') return 'text-bg-success';
      if (state === 'archived') return 'text-bg-warning text-dark';
      return 'text-bg-light';
    },

    get_application_state_label(state) {
      if (state === 'applied') return 'Applied';
      if (state === 'archived') return 'In Progress';
      return '';
    },

    get_job_action_label(job = this.job) {
      if (this.opening_application && job?.applicationState === 'archived') return 'Opening...';
      if (job?.alreadyApplied) return 'Applied';
      if (job?.applicationState === 'archived') return 'Continue';
      return 'Apply';
    },

    to_number(value) {
      const parsed = Number(value);
      return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
    },

    get_job_application_form_id(job = this.job) {
      const selected_advert_id = this.to_number(job?.advertId);
      const selected_entity_type_id = this.to_number(job?.id);
      const applications = Array.isArray(this.application_list) ? this.application_list : [];

      const candidates = applications
        .map((application) => ({
          application_form_id: this.to_number(
            application?.current_application_form_id ?? application?.application_form_id
          ),
          advert_id: this.to_number(application?.advert_id ?? application?.advert?.id),
          entity_type_id: this.to_number(
            application?.current_entity_type?.id ?? application?.entity_type?.id
          ),
          is_withdrawn: Boolean(application?.is_withdrawn),
        }))
        .filter((application) => application.application_form_id && !application.is_withdrawn);

      const exact_advert_match = candidates.find((application) => (
        selected_advert_id && application.advert_id === selected_advert_id
      ));
      if (exact_advert_match?.application_form_id) {
        return exact_advert_match.application_form_id;
      }

      const entity_type_match = candidates.find((application) => (
        selected_entity_type_id && application.entity_type_id === selected_entity_type_id
      ));
      return entity_type_match?.application_form_id || null;
    },

    close_job_details_modal() {
      const modal_el = document.getElementById('job-details-modal');
      if (!modal_el) return;
      const modal = window.bootstrap?.Modal?.getInstance(modal_el);
      if (modal) modal.hide();
    },

    continue_existing_application(job = this.job) {
      const application_form_id = this.to_number(
        job?.applicationFormId ?? this.get_job_application_form_id(job)
      );
      if (!application_form_id) {
        return false;
      }

      this.opening_application = true;
      this.update_vacancy_application_state(
        { ...job, applicationFormId: application_form_id },
        'archived'
      );
      sessionStorage.setItem('application_form_id', String(application_form_id));
      sessionStorage.setItem('entity_applying', 'true');
      this.close_job_details_modal();
      this.$router.push({
        path: '/attribute_forms',
        query: { application_form_id: String(application_form_id) },
      }).finally(() => {
        this.opening_application = false;
      });
      return true;
    },

    update_vacancy_application_state(target_job, application_state) {
      const normalized_state = this.normalize_application_state(application_state);
      const selected_advert_id = Number(target_job?.advertId || 0);
      const selected_entity_type_id = Number(target_job?.id || 0);
      const selected_application_form_id = this.to_number(
        target_job?.applicationFormId ?? this.get_job_application_form_id(target_job)
      );

      this.vacancies = (this.vacancies || []).map((job) => {
        const job_advert_id = Number(job?.advertId || 0);
        const job_entity_type_id = Number(job?.id || 0);
        const is_same_advert = selected_advert_id && job_advert_id === selected_advert_id;
        const is_same_entity_when_no_advert = !selected_advert_id && job_entity_type_id === selected_entity_type_id;

        if (!is_same_advert && !is_same_entity_when_no_advert) {
          return job;
        }

        return {
          ...job,
          applicationFormId: selected_application_form_id || job?.applicationFormId || null,
          applicationState: normalized_state,
          alreadyApplied: normalized_state === 'applied',
        };
      });

      this.job = {
        ...this.job,
        applicationFormId: selected_application_form_id || this.job?.applicationFormId || null,
        applicationState: normalized_state,
        alreadyApplied: normalized_state === 'applied',
      };
    },

    format_period(published_date, closing_date) {
      const from = published_date ? new Date(published_date).toLocaleDateString() : 'Open';
      const to = closing_date ? new Date(closing_date).toLocaleDateString() : 'Open';
      return `${from} to ${to}`;
    },

    normalize_vacancy(job_row, advert_row) {
      const advert = advert_row || {};
      const job_title = advert.title || job_row.entity_type_name || 'Untitled Job';
      const closing_date = advert.closing_date || job_row.closing_date || null;
      const published_date = advert.published_date || job_row.published_date || null;
      return {
        id: job_row.id || null,
        advertId: advert.id || null,
        alreadyApplied: false,
        applicationState: null,
        title: job_title,
        jobTitle: job_title,
        departmentName: job_row.project_name || job_row.department_name || '',
        status: this.infer_job_status(closing_date),
        closingDate: closing_date,
        publishedDate: published_date,
        recruitingPeriod: this.format_period(published_date, closing_date),
        referenceNumber: advert.reference_number || job_row.reference_number || '-',
        summary: (advert.details || job_row.entity_type_description || '').slice(0, 120),
        shareLink: job_row.share_link || '',
      };
    },

    async fetch_vacancies() {
      if (this.loading_jobs) return;
      this.loading_jobs = true;
      try {
        const response = await axios.get(PUBLIC_JOB_CATALOG_URL);
        const payload = response.data?.data || {};
        const job_rows = payload.jobs || [];
        this.vacancies = job_rows.flatMap((job_row) => {
          const adverts = Array.isArray(job_row?.adverts) && job_row.adverts.length
            ? job_row.adverts
            : [];
          return adverts.map((advert_row) => this.normalize_vacancy(job_row, advert_row));
        });
      } catch (error) {
        const message = error.response?.data?.message || error.message || 'Unknown error';
        this.show_error('Error loading vacancies: ' + message);
      } finally {
        this.loading_jobs = false;
      }
    },

    async fetch_profile_completion() {
      try {
        const [user_resp, form_resp] = await Promise.all([
          axios.get(GET_USER_PROFILE_DETAILS_URL, { headers: this.headers }),
          axios.get(GET_APPLICATION_FORMS, { headers: this.headers, params: { profile: 1 } }),
        ]);

        const user_data = user_resp?.data?.data || {};
        const identity_values = [
          user_data.first_name,
          user_data.last_name,
          user_data.email,
          user_data.phone_number,
        ];

        const body = form_resp.data;
        const forms = Array.isArray(body)
          ? body
          : (Array.isArray(body?.data) ? body.data : (body?.data ? [body.data] : []));

        const raw_sections = forms[0]?.form?.sections || [];
        const question_values = raw_sections
          .flatMap(s => (s.questions || []).map(q => q.answer))
          .filter(a => a !== undefined);

        const all = [...identity_values, ...question_values];
        if (!all.length) return;

        const is_filled = v => {
          if (v == null || v === '') return false;
          if (Array.isArray(v)) return v.length > 0;
          if (typeof v === 'object') {
            const inner = v.answer ?? v.answer_text ?? null;
            return inner != null && String(inner).trim() !== '' && inner !== 'Not provided';
          }
          return String(v).trim() !== '' && String(v) !== 'Not provided';
        };

        const filled = all.filter(is_filled).length;
        const calculated_value = Math.round((filled / all.length) * 100);
        this.on_profile_completion_update(calculated_value);
      } catch (_err) {
        // fail silently Ã¢â‚¬â€ percentage stays at 0
      } finally {
        if (!this.profile_completion_timer) {
          this.profile_completion_ready = true;
        }
      }
    },

    on_profile_completion_update(value) {
      const parsed = Number(value);
      if (!Number.isFinite(parsed)) {
        return;
      }

      const normalized = Math.max(0, Math.min(100, Math.round(parsed)));
      this.profile_completion_buffer = normalized;
      this.profile_completion_ready = false;

      if (this.profile_completion_timer) {
        clearTimeout(this.profile_completion_timer);
      }

      // Wait for updates to settle, then show only one final value.
      this.profile_completion_timer = setTimeout(() => {
        this.profile_completion_value = this.profile_completion_buffer ?? 0;
        this.profile_completion_ready = true;
        this.profile_completion_timer = null;
      }, 700);
    },

    async fetch_profile_basic() {
      try {
        const response = await axios.get(GET_USER_PROFILE_DETAILS_URL, { headers: this.headers });
        const user_data = response?.data?.data || {};
        const first_name = user_data.first_name || '';
        const last_name = user_data.last_name || '';
        this.current_user_name = user_data.full_name || `${first_name} ${last_name}`.trim() || sessionStorage.getItem('lead_name') || '';
        this.profile.fullName = this.current_user_name;
        this.profile.email = user_data.email || '';
        this.profile.phone = user_data.phone_number || '';
      } catch (_error) {
        this.current_user_name = sessionStorage.getItem('lead_name') || '';
      }
    },

    async open_job_details(job) {
      this.job = {
        ...job,
        applicationFormId: job?.applicationFormId ?? this.get_job_application_form_id(job),
        alreadyApplied: job.alreadyApplied ?? false,
        applicationState: this.normalize_application_state(job.applicationState),
        competencies: [],
      };

      await this.load_job_profile_for_modal(job.id, job.advertId);
      await this.load_advert_data_for_modal(job.id, job.advertId);
    },

    async check_single_job_applied(entity_type_id) {
      if (!get_token() || !entity_type_id) return false;
      try {
        const resp = await axios.get(
          CHECK_APPLIED_STATUS_URL,
          { params: { entity_type_id }, headers: get_headers() }
        );
        return resp?.data?.already_applied === true;
      } catch {
        return false;
      }
    },

    async sync_applied_statuses() {
      if (!get_token()) return;
      const ids = [
        ...new Set(
          (this.table_safe_application_list || [])
            .map(row => row._entity_type_id)
            .filter(Boolean)
        )
      ];
      if (!ids.length) return;
      const results = await Promise.all(
        ids.map(async id => ({ id, applied: await this.check_single_job_applied(id) }))
      );
      const map = { ...this.applied_status_map };
      results.forEach(({ id, applied }) => { map[id] = applied; });
      this.applied_status_map = map;
    },

    async sync_vacancy_applied_statuses() {
      if (!get_token() || !(this.vacancies || []).length || this._syncingVacancies) return;
      this._syncingVacancies = true;
      try {
        const resp = await axios.get(
          GET_USER_APPLIED_ENTITY_TYPE_IDS_URL,
          { headers: get_headers() }
        );
        const applied_advert_ids = new Set(
          (resp?.data?.applied_advert_ids || []).map(Number).filter(Boolean)
        );
        const applied_entity_type_ids = new Set(
          (resp?.data?.applied_entity_type_ids || resp?.data?.applied_entity_types || []).map(Number).filter(Boolean)
        );
        const archived_advert_ids = new Set(
          (resp?.data?.archived_advert_ids || []).map(Number).filter(Boolean)
        );
        const archived_entity_type_ids = new Set(
          (resp?.data?.archived_entity_type_ids || []).map(Number).filter(Boolean)
        );
        this.vacancies = this.vacancies.map(v => {
          const advert_id = Number(v.advertId || 0);
          const entity_type_id = Number(v.id || v.entity_type_id || 0);
          const applied_by_advert = advert_id && applied_advert_ids.has(advert_id);
          const applied_by_entity_type = entity_type_id && applied_entity_type_ids.has(entity_type_id);
          const archived_by_advert = advert_id && archived_advert_ids.has(advert_id);
          const archived_by_entity_type = entity_type_id && archived_entity_type_ids.has(entity_type_id);
          const applicationState = applied_by_advert || applied_by_entity_type
            ? 'applied'
            : (archived_by_advert || archived_by_entity_type ? 'archived' : null);
          return {
            ...v,
            applicationState,
            alreadyApplied: applicationState === 'applied',
          };
        });
      } catch {
        // Non-critical Ã¢â‚¬â€ vacancies still show, just without applied badges.
      } finally {
        this._syncingVacancies = false;
      }
    },

    async withdraw_application(application_id) {
      if (!application_id) return;

      this.show_confirm(
        'Withdraw Application',
        'Are you sure you want to withdraw this application? This action cannot be undone.',
        async () => {
          await this.execute_withdraw_application(application_id);
        }
      );
    },

    async execute_withdraw_application(application_id) {
      try {
        await axios.post(WITHDRAW_APPLICATION_URL, { application_id }, { headers: this.headers });

        // Optimistically move application to withdrawn bucket for immediate UI feedback.
        this.table_safe_application_list = (this.table_safe_application_list || []).map((row) => {
          if (Number(row?._application_id) !== Number(application_id)) {
            return row;
          }
          return {
            ...row,
            _is_withdrawn: true,
            Status: 'Withdrawn',
          };
        });

        this.applicationTrackerTab = 'withdrawn';
        this.show_success('Application withdrawn successfully.');
        this.get_user_forms(null);
      } catch (err) {
        this.show_error('Could not withdraw the application. Please try again.');
      }
    },

    async applyForJob() {
      if (!this.job?.id) {
        this.show_error('Please select a job first.');
        return;
      }
      if (this.job?.applicationState === 'archived' && this.continue_existing_application(this.job)) {
        return;
      }
      const token = get_token();
      if (token) {
        try {
          this.opening_application = true;
          const response = await axios.post(
            APPLY_FOR_ENTITY_TYPE,
            { entity_type_id: this.job.id, advert_id: this.job.advertId },
            { headers: get_headers() }
          );
          const data = response.data;
          this.close_job_details_modal();
          if (data.status === 'success') {
            if (data.already_applied === true) {
              this.update_vacancy_application_state(this.job, data.application_state || 'applied');
              this.show_info(data.message || 'You already applied for this job.');
              return;
            }
            if (data.application_form_id) {
              this.update_vacancy_application_state(
                { ...this.job, applicationFormId: data.application_form_id },
                data.application_state || 'archived'
              );
              sessionStorage.setItem('application_form_id', data.application_form_id);
              sessionStorage.setItem('entity_applying', 'true');
              this.$router.push({
                path: '/attribute_forms',
                query: { application_form_id: String(data.application_form_id) },
              });
            } else {
              this.show_info('Your application has been created.');
            }
          } else {
            this.show_error(data.message || 'Could not create application.');
          }
        } catch (error) {
          this.show_error(error.response?.data?.message || 'Error creating application.');
        } finally {
          this.opening_application = false;
        }
        return;
      }
      if (!this.job.shareLink) {
        this.show_error('Onboarding link is not available for this job yet.');
        return;
      }
      window.location.assign(this.job.shareLink);
    },

    format_status_label(key) {
      return (key || "").toString().replace(/[-_]/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    },

    normalize_key(key) {
      if (!key) return "";
      const k = key.toString().trim().toLowerCase();
      const map = this.STATUS_ALIASES || {};
      // map aliases like "pending" -> "in-progress"
      return Object.prototype.hasOwnProperty.call(map, k) ? Reflect.get(map, k) : k;
    },

    get_date_filter_window_ms() {
      const selected = this.vacancy_filters?.datePosted || 'any_time';
      if (selected === 'past_24_hours') return 24 * 60 * 60 * 1000;
      if (selected === 'past_week') return 7 * 24 * 60 * 60 * 1000;
      if (selected === 'past_month') return 30 * 24 * 60 * 60 * 1000;
      return null;
    },

    is_within_selected_date(date_value) {
      const window_ms = this.get_date_filter_window_ms();
      if (window_ms == null) return true;
      if (!date_value) return false;

      const timestamp = new Date(date_value).getTime();
      if (Number.isNaN(timestamp)) return false;

      return timestamp >= (Date.now() - window_ms);
    },

    clear_vacancy_filters() {
      this.vacancy_filters = {
        programmeId: '',
        status: '',
        search: '',
        datePosted: 'any_time',
      };
      this.vacancy_current_page = 1;
    },

    on_vacancy_filter_change() {
      this.vacancy_current_page = 1;
    },
  },
};



